import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultFieldsetContext = {
  disabled: false,
  size: 'default'
};
export const FieldsetContext = /*#__PURE__*/createContext(defaultFieldsetContext);
const {
  Consumer,
  Provider
} = FieldsetContext;
export { Consumer as FieldsetContextConsumer };
export { Consumer };
export const FieldsetContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Provider, {
    value: props,
    children: children
  });
};
export const useFieldsetContext = () => {
  const state = useContext(FieldsetContext);
  if (!state) {
    throw new Error('useFieldsetContext must be used within FieldsetContextProvider');
  }
  return state;
};